import {Component} from 'react';
import axios from "axios"
import Nav from "../../Componet/Nav";
import Swal from "sweetalert2";
import myconfig from "../../myconfig";
import $ from 'jquery';
import { Modal,Button } from 'react-bootstrap';
import Get_Order from "../Sub_Componet/Get_Order";

let source = axios.CancelToken.source();

class Allocate_allocate_vehicle extends Component {
    constructor() {
        super();
        var date = new Date();
        this.state = {
            st: date.toISOString().split('T')[0],
            ed: date.toISOString().split('T')[0],
            datas: [],
            datasl: false,
            filtered: [],
            allocation_id:-1,
            frightno:'',
            cushow: false,
            orders: [],
            ordersl: false,

            vehicles:[],
            vehicleload:false,
            assignshow:false,
            wizard:1,
        }
    }

    async componentDidMount() {
        let order_id = new URLSearchParams(this.props.location.search).get("order_id");
        let baseurl = myconfig.get_single_order;
        let redirecttologin = myconfig.redirecttologin;
        await axios.post(baseurl, {
            sid: window.localStorage.getItem("ntfms_sid"),
            id: order_id,
        }, {cancelToken: source.token}).then(res => {
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                if (res.data.data == null) {
                    this.setState({
                        cushow: true,
                        orders: [],
                        ordersl: false,
                    })
                } else {
                    let baseurl = myconfig.get_allocations;
                    let redirecttologin = myconfig.redirecttologin;
                    axios.post(baseurl, {
                        sid: window.localStorage.getItem("ntfms_sid"),
                        order_id: order_id,
                    }, {cancelToken: source.token}).then(res => {
                        if (res.data.auth == false) {
                            window.localStorage.setItem("ntfms_sid", null);
                            window.localStorage.setItem("ntfms_username", null);
                            window.localStorage.setItem("ntfms_name", null);
                            var win = window.open(redirecttologin, "_self");
                        } else if (res.data.success == false) {
                            Swal.fire({
                                title: 'Error!',
                                text: res.data.msg,
                                icon: 'error',
                                confirmButtonText: 'Okay'
                            })
                        } else {
                            this.setState({
                                datas: res.data,
                                datasl: true,
                            })
                        }
                    }).catch((e) => {
                        console.log(e.message);
                    });
                }
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }

    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }

    inputmgt = (event) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value,
        })
    }
    get_data_by_date = (event) => {
        event.preventDefault()
        this.fetch_data_by_date();
    }
    fetch_data_by_date = () => {
        let baseurl = myconfig.get_order_for_allocation;
        let redirecttologin = myconfig.redirecttologin;
        this.setState({
            datas: [],
            datasl: false,
        })
        let order_id = new URLSearchParams(this.props.location.search).get("order_id");
        axios.post(baseurl, {
            sid: window.localStorage.getItem("ntfms_sid"),
            st:this.state.st,
            ed:this.state.ed,
        }, {cancelToken: source.token}).then(res => {
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    orders: res.data.datas,
                    ordersl: true,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }
    tabledata = () => {
        // <td><a href="" onClick={(event => {
        //                     this.showcu(event, false, value.id)
        //                 })}>Edit</a> |<a href="#">Delete</a></td>
        let count = 0;
        let retdata = null;
        if (this.state.ordersl) {
            retdata = this.state.orders.map(value => {
                count = count + 1
                return (<tr>
                    <td>{count}</td>
                    <td><a href="#" onClick={event => this.submitcu(event, value.id)}>Select</a></td>
                    <td>{value.orderdate}</td>
                    <td>{value.order_no}</td>
                    <td>{value.companyname}</td>
                    <td>{value.orgname}</td>
                    <td>{value.desname}</td>
                    <td>{value.cargo_name}</td>
                    <td>{value.volume}</td>
                    <td>{value.sale_type}</td>
                    <td>{value.type}</td>
                    <td>{value.transport_rate_q}</td>
                    <td>{value.cement_rate_q}</td>
                    <td>{value.cement_cost}</td>
                    <td>{value.stdate}</td>
                    <td>{value.eddate}</td>
                </tr>)
            })
        }
        return (<>{retdata}</>)
    }
    tabledata2 = () => {
        // <td><a href="" onClick={(event => {
        //                     this.showcu(event, false, value.id)
        //                 })}>Edit</a> |<a href="#">Delete</a></td>
        let count = 0;
        let retdata = null;
        if (this.state.datasl) {
            retdata = this.state.datas.datas.map(value => {
                count = count + 1
                return (<tr>
                    <td>{count}</td>
                    <td><a href="#" onClick={event => this.assignvehicle(event, value.id)}>Assign</a></td>
                    <td>{value.actfuelqtyempty}</td>
                    <td>{value.actprediemempty}</td>
                    <td>{value.acthandlefeeempty}</td>
                    <td>{value.actfuelqtyload}</td>
                    <td>{value.actpredieload}</td>
                    <td>{value.acthandlefeeload}</td>
                    <td>{value.loadedweight}</td>
                    <td>{value.unloadedweight}</td>
                </tr>)
            })
        }
        return (<>{retdata}</>)
    }

    wizard_1=()=>{
        let tabledata=null;
        if(this.state.vehicleload){
            let count=0;
            tabledata = this.state.vehicles.map(value => {
                count = count + 1
                return (<tr>
                    <td>{count}</td>
                    <td>
                        <a href="#" onClick={(event => this.wizard_1_btn(event,value))}> Select </a>
                    </td>
                    <td>{value.plate_no}</td>
                    <td>{value.tran_name}</td>
                    <td>{value.tran_type}</td>
                    <td>{value.dri_name}</td>
                    <td>{value.dri_phoneno}</td>
                    <td>{value.tra_plateno}</td>
                    <td>{value.loc}</td>
                    <td>{value.avl}</td>
                    <td>{value.status}</td>
                </tr>)
            })
        }

        return(<>
            <div className="card">
                <div className="card-header">
                    <div className="card-tools">
                        <div className="input-group input-group-sm" style={{width: '150px'}}>
                            <input type="text" name="table_search" className="form-control float-right" placeholder="Search" />
                            <div className="input-group-append">
                                <button type="submit" className="btn btn-default">
                                    <i className="fas fa-search" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-header">
                    <h3 className="card-title">Available Truck List</h3>
                    <div className="card-tools">
                    </div>
                </div>
                <div className="card">
                <div className="card-body">
                    <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Fright No</label>
                        <input name="frightno" value={this.state.frightno} onChange={this.inputmgt}
                               type="text" className="form-control"/>
                    </div>
                </div>
                </div>
                {/* /.card-header */}
                <div className="card-body table-responsive p-0" style={{height: '500px'}}>

                    <table className="table table-head-fixed text-nowrap">
                        <thead>
                        <tr>
                            <th>#</th>
                            <th>Action</th>
                            <th>Plate No </th>
                            <th>Transporter</th>
                            <th>Type</th>
                            <th>Driver Name</th>
                            <th>Phone #</th>
                            <th>Trailer</th>
                            <th>Location</th>
                            <th>Update Time</th>
                            <th>Status</th>
                        </tr>
                        </thead>
                        <tbody>
                        {tabledata}
                        </tbody>
                    </table>
                </div>
                {/* /.card-body */}
            </div>
            {/* /.card */}
        </>)
    }
    wizard_1_btn = (event,value) => {
        event.preventDefault();
        if (value.status == "WAITING_FOR_ORDER") {
            /*Swal.fire({
                title: "An input!",
                text: "Write something interesting:",
                input: 'text',
            }).then((result) => {
                if (result.value) {
                    console.log("Result: " + result.value);
                }
            });*/
            let baseurl = myconfig.vehicle_allocation;
            let redirecttologin = myconfig.redirecttologin;
            let sid = new URLSearchParams(this.props.location.search).get("sid");
            let user = new URLSearchParams(this.props.location.search).get("user");
            let allocate_id = new URLSearchParams(this.props.location.search).get("allocate_id");
            axios.post(baseurl, {
                "sid":window.localStorage.getItem("ntfms_sid"),
                "allocation_id": this.state.allocation_id,
                "assignment_id":value.id,
                "frightno": this.state.frightno,
                "wiz_algo": this.state.wizard,
            }, {cancelToken: source.token}).then(res => {
                console.log(res.data)
                if (res.data.auth == false) {
                     window.localStorage.setItem("ntfms_sid", null);
                      window.localStorage.setItem("ntfms_username", null);
                      window.localStorage.setItem("ntfms_name", null);
                      var win = window.open(redirecttologin, "_self");
                } else if (res.data.success == false) {
                    Swal.fire({
                        title: 'Error!',
                        text: res.data.msg,
                        icon: 'error',
                        confirmButtonText: 'Okay'
                    })
                } else {
                    Swal.fire({
                        title: 'Success!',
                        text: "Vehicle select successfully",
                        icon: 'success',
                        confirmButtonText: 'Okay'
                    }).then(value => {
                        this.fetch_data_by_date()
                    })
                }
            }).catch((e) => {
                console.log(e.message);
            });
        }
        else if(value.status=="HEADING_TO_STATION"){
            this.setState({
                wizard:2,
                value:value,
            })
        }
    }
    wizard_2=()=>{
        return(<>
            <div className="card card-warning card-outline">
                <div className="card-header">
                    <h3 className="card-title">
                        <i className="fas fa-search" /> Type of trip select
                    </h3>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <button type="button" onClick={(event => this.wizard_2_btn(event,3))} className="form-control btn btn-success">
                                    From GPS
                                </button>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <button type="button" onClick={(event => this.wizard_2_btn(event,1))} className="form-control btn btn-dark">
                                    Same as Orgin
                                </button>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <button type="button" onClick={(event => this.wizard_2_btn(event,2))} className="form-control btn btn-dark">
                                    From Route Master
                                </button>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <button type="button" className="form-control btn btn-info">
                                    Others
                                </button>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <button type="button" className="form-control btn btn-danger">
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="text-muted mt-3">
                        For more information look at <a href="#">apps.ztsus.com</a>
                    </div>
                </div>
            </div>
        </>)
    }
    wizard_2_btn = (event,type) => {
        //type 1 for Same as load
        //type 2 for from load point
        event.preventDefault();
        if(type==1){
            let baseurl = myconfig.vehicle_allocation;
            let redirecttologin = myconfig.redirecttologin;
            let value = this.state.value;
            axios.post(baseurl, {
                "sid":window.localStorage.getItem("ntfms_sid"),
                "allocation_id": this.state.allocation_id,
                "assignment_id":value.id,
                "frightno": this.state.frightno,
                "wiz_algo": 2,
            }, {cancelToken: source.token}).then(res => {
                console.log(res.data)
                if (res.data.auth == false) {
                    window.localStorage.setItem("ntfms_sid", null);
                    window.localStorage.setItem("ntfms_username", null);
                    window.localStorage.setItem("ntfms_name", null);
                    var win = window.open(redirecttologin, "_self");
                } else if (res.data.success == false) {
                    Swal.fire({
                        title: 'Error!',
                        text: res.data.msg,
                        icon: 'error',
                        confirmButtonText: 'Okay'
                    })
                } else {
                    Swal.fire({
                        title: 'Success!',
                        text: "Vehicle select successfully",
                        icon: 'success',
                        confirmButtonText: 'Okay'
                    }).then(value => {
                        this.fetch_data_by_date()
                    })
                }
            }).catch((e) => {
                console.log(e.message);
            });
        }
        else if(type==2){
            let baseurl = myconfig.getlocations;
            let redirecttologin = myconfig.redirecttologin;
            axios.post(baseurl, {
            }, {cancelToken: source.token}).then(res => {
                console.log(res.data)
                if (res.data.auth == false) {
                    /*  window.localStorage.setItem("fas_sid", null);
                      window.localStorage.setItem("fas_username", null);
                      window.localStorage.setItem("fas_name", null);
                      var win = window.open(redirecttologin, "_self");*/
                } else if (res.data.success == false) {
                    Swal.fire({
                        title: 'Error!',
                        text: res.data.message,
                        icon: 'error',
                        confirmButtonText: 'Okay'
                    })
                } else {
                    this.setState({
                        locations:res.data.datas,
                        locationload:true,
                        locationselected:"-1",
                        wizard:3,
                    })
                }
            }).catch((e) => {
                console.log(e.message);
            });
        }
        else if(type==3){
            this.setState({
                wizard:4,
            })
        }
    }
    wizard_3=()=>{
        let dataoption=null;
        if(this.state.locationload){
            dataoption=this.state.locations.map(value => {
                return (<option value={value.id}>{value.loc_full_name}</option>)
            })
        }
        return(<>
            <div className="card card-warning card-outline">
                <div className="card-header">
                    <h3 className="card-title">
                        <i className="fas fa-book" /> From Route Master
                    </h3>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label>Route Orgin</label>
                                    <select name="locationselected" value={this.state.locationselected} className="form-control" onChange={this.inputmgt}>
                                        {dataoption}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-footer">
                    <button type="submit" className="btn btn-primary" onClick={this.wizard_3_btn}>Select</button>
                </div>
            </div>
        </>)
    }
    wizard_3_btn = (event) => {
        event.preventDefault()
        let baseurl = myconfig.vehicle_allocation;
        let redirecttologin = myconfig.redirecttologin;
        let value = this.state.value;
        axios.post(baseurl, {
            "sid":window.localStorage.getItem("ntfms_sid"),
            "allocation_id": this.state.allocation_id,
            "assignment_id":value.id,
            "frightno": this.state.frightno,
            "locationselected":this.state.locationselected,
            "wiz_algo": 3,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                Swal.fire({
                    title: 'Success!',
                    text: "Vehicle select successfully",
                    icon: 'success',
                    confirmButtonText: 'Okay'
                }).then(value => {
                    this.fetch_data_by_date()
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }
    wizard_4=()=>{
        return(<>
            <div className="card card-warning card-outline">
                <div className="card-header">
                    <h3 className="card-title">
                        <i className="fas fa-gears" /> From GPS Data
                    </h3>
                </div>
                <div className="card-body">
                    <form>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Current Location</label>
                                    <input name="cur_location" value={this.state.cur_location} className="form-control" type="text" onChange={this.inputmgt}/>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Current Coordinate</label>
                                    <input  name="cur_cor" value={this.state.cur_cor} className="form-control" type="text" onChange={this.inputmgt}/>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Update Time</label>
                                    <input disabled name="cur_avl" value={this.state.cur_avl} className="form-control" type="text" onChange={this.inputmgt}/>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Distance</label>
                                    <input  name="cur_distance" value={this.state.cur_distance} className="form-control" type="text" onChange={this.inputmgt}/>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Location Short Name</label>
                                    <input  name="cur_short_name" value={this.state.cur_short_name} className="form-control" type="text" onChange={this.inputmgt}/>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Fuel Empty</label>
                                    <input  name="cur_fuel_empty" value={this.state.cur_fuel_empty} className="form-control" type="text" onChange={this.inputmgt}/>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Handling Fee Empty</label>
                                    <input  name="cur_handling_fee" value={this.state.cur_handling_fee} className="form-control" type="text" onChange={this.inputmgt}/>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div className="card-footer d-flex justify-content-between">
                    <button type="submit" className="btn btn-primary" onClick={this.wizard_4_btn}>Submit</button>
                    <button type="submit" className="btn btn-primary" onClick={this.getfromgps}>From GPS</button>
                    <button type="submit" className="btn btn-primary" onClick={this.getfromcor}>From Coordinate</button>
                </div>
            </div>
        </>)
    }
    wizard_4_btn = (event) => {
        event.preventDefault()
        if (this.state.cur_location == "") {
            Swal.fire({
                title: 'Error!',
                text: "Please enter location",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        }
        else if (this.state.cur_cor == "") {
            Swal.fire({
                title: 'Error!',
                text: "Please enter location coordinate",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        }
        else if (this.state.cur_distance == "" || isNaN(this.state.cur_distance)) {
            Swal.fire({
                title: 'Error!',
                text: "Please enter distance",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        }
        else if (this.state.cur_distance < 0) {
            Swal.fire({
                title: 'Error!',
                text: "Distance must be equal to zero or above",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        }
        else if (this.state.cur_fuel_empty == "" || isNaN(this.state.cur_fuel_empty)) {
            Swal.fire({
                title: 'Error!',
                text: "Please enter fuel empty",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        }
        else if (this.state.cur_fuel_empty <= 0) {
            Swal.fire({
                title: 'Error!',
                text: "Fuel empty can not be zero and below",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        }
        else if (this.state.cur_handling_fee == "" || isNaN(this.state.cur_handling_fee)) {
            Swal.fire({
                title: 'Error!',
                text: "Please enter handling fee empty",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        }
        else if (this.state.cur_handling_fee < 0) {
            Swal.fire({
                title: 'Error!',
                text: "Handling fee must be equal to zero or above",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        }
        else {
            let cur_distance=parseFloat(this.state.cur_distance);
            let cur_fuel_empty=parseFloat(this.state.cur_fuel_empty);
            let cur_fule_qty_empty=parseFloat(cur_distance/cur_fuel_empty).toFixed(2)
            let cur_perdiem_empty=parseFloat(cur_distance*4.33*0.25).toFixed(2)
            let cur_handling_fee=parseFloat(this.state.cur_handling_fee);
            let baseurl = myconfig.vehicle_allocation;
            let redirecttologin = myconfig.redirecttologin;
            let value = this.state.value;
            axios.post(baseurl, {
                "sid":window.localStorage.getItem("ntfms_sid"),
                "allocation_id": this.state.allocation_id,
                "assignment_id":value.id,
                "frightno": this.state.frightno,
                "wiz_algo": 4,
                "cur_location": this.state.cur_location,
                "cur_cor": this.state.cur_cor,
                "cur_short_name": this.state.cur_short_name,
                "cur_distance": cur_distance,
                "cur_fuel_empty": cur_fuel_empty,
                "cur_fule_qty_empty": cur_fule_qty_empty,
                "cur_perdiem_empty": cur_perdiem_empty,
                "cur_handling_fee": cur_handling_fee,
            }, {cancelToken: source.token}).then(res => {
                console.log(res.data)
                if (res.data.auth == false) {
                    window.localStorage.setItem("ntfms_sid", null);
                    window.localStorage.setItem("ntfms_username", null);
                    window.localStorage.setItem("ntfms_name", null);
                    var win = window.open(redirecttologin, "_self");
                } else if (res.data.success == false) {
                    Swal.fire({
                        title: 'Error!',
                        text: res.data.msg,
                        icon: 'error',
                        confirmButtonText: 'Okay'
                    })
                } else {
                    Swal.fire({
                        title: 'Success!',
                        text: "Vehicle select successfully",
                        icon: 'success',
                        confirmButtonText: 'Okay'
                    }).then(value => {
                        this.fetch_data_by_date()
                    })
                }
            }).catch((e) => {
                console.log(e.message);
            });
        }
    }
    getfromgps = (event) => {
        event.preventDefault()
        let baseurl = myconfig.getemptyfromgps;
        let redirecttologin = myconfig.redirecttologin;
        let sid = new URLSearchParams(this.props.location.search).get("sid");
        let user = new URLSearchParams(this.props.location.search).get("user");
        let allocate_id = new URLSearchParams(this.props.location.search).get("allocate_id");
        console.log(this.state.value)
        axios.post(baseurl, {
            allocate_id:this.state.allocation_id,
            truck_id:this.state.value.truck_id,
            sid:sid,
            user:user,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                /*  window.localStorage.setItem("fas_sid", null);
                  window.localStorage.setItem("fas_username", null);
                  window.localStorage.setItem("fas_name", null);
                  var win = window.open(redirecttologin, "_self");*/
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    cur_distance:res.data.data.cur_distance,
                    cur_location:res.data.data.cur_location,
                    cur_cor:res.data.data.cur_cor,
                    cur_avl:res.data.data.cur_avl,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }
    getfromcor = (event) => {
        event.preventDefault()
        let baseurl = myconfig.getemptyfromcor;
        let redirecttologin = myconfig.redirecttologin;
        let sid = new URLSearchParams(this.props.location.search).get("sid");
        let user = new URLSearchParams(this.props.location.search).get("user");
        let allocate_id = new URLSearchParams(this.props.location.search).get("allocate_id");
        axios.post(baseurl, {
            allocate_id:allocate_id,
            truck_id:this.state.value.truck_id,
            sid:sid,
            user:user,
            cur_cor:this.state.cur_cor,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                /*  window.localStorage.setItem("fas_sid", null);
                  window.localStorage.setItem("fas_username", null);
                  window.localStorage.setItem("fas_name", null);
                  var win = window.open(redirecttologin, "_self");*/
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    cur_distance:res.data.data.cur_distance,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }

    assignvehicle = (event,id) => {
        event.preventDefault()
        let baseurl = myconfig.getavavehicles;
        let sid = new URLSearchParams(this.props.location.search).get("sid");
        let user = new URLSearchParams(this.props.location.search).get("user");
        axios.post(baseurl, {
            "sid": sid,
            "user": user,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                /*  window.localStorage.setItem("fas_sid", null);
                  window.localStorage.setItem("fas_username", null);
                  window.localStorage.setItem("fas_name", null);
                  var win = window.open(redirecttologin, "_self");*/
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.message,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    vehicles:res.data.datas,
                    vehicleload:true,
                    assignshow:true,
                    wizard:1,
                    allocation_id:id,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }

    hideassign = () => {
        this.setState({
            assignshow: false,
        })
    }
    modalassign=()=> {
        let display=null;
        let size="md";
        if(this.state.wizard==1){
            display=this.wizard_1()
            size="lg"
        }
        else if(this.state.wizard==2)
            display=this.wizard_2()
        else if(this.state.wizard==3)
            display=this.wizard_3()
        else if(this.state.wizard==4)
            display=this.wizard_4()
        else if(this.state.wizard==5)
            display=this.wizard_5()
        return (<Modal
                size={size}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.state.assignshow}
                onHide={this.hideassign}>
                <Modal.Header><h4>Vehicle Assigment</h4>
                    <small>({this.state.msg})</small></Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-12">
                            {display}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
/*    btnassign = (event,assign_id) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        let id="-1"
        let vehplate='NA'
        let vehcapcity='NA'
        let vehtype='NA'
        let vehtname='NA'
        let traplate='NA'
        let driname='NA'
        let drilicno='NA'
        let drilicvalid='NA'
        let driphone='NA'
        let actfuelempty=''
        let actfuelload=''
        let actperdiumload=''
        let actallowanceempty=''
        let acthandlingempty=''
        let acthandlingload=''
        let estfuelempty=''
        let estfuelload=''
        let estperdiumload=''
        let estallowanceempty=''
        let esthandlingempty=''
        let esthandlingload=''
        let temp=this.state.objs.retvehicles.find(o=>o.id==assign_id)
        if(temp!==undefined)
        {
            console.log(temp)
            vehplate=temp.plateno
            vehcapcity=temp.capacity
            vehtype=temp.type
            vehtname=temp.tname

        }
        temp=this.state.objs.rettrailes.find(o=>o.id==assign_id)
        if(temp!==undefined)
        {
            traplate=temp.plateno
        }
        temp=this.state.vehicles.find(o=>o.assign_id==assign_id)

        if(temp!==undefined)
        {
            actfuelempty=temp.fuelqtyempty
            actfuelload=temp.fuelqtyload
            actperdiumload=temp.predimload
            actallowanceempty=temp.predimallownce
            acthandlingempty=temp.handlinefeeempty
            acthandlingload=temp.handlinefeeloaded

            estfuelempty=actfuelempty
            estfuelload=actfuelload
            estperdiumload=actperdiumload
            estallowanceempty=actallowanceempty
            esthandlingempty=acthandlingempty
            esthandlingload=acthandlingload
        }
        this.setState({
            [name]: value,
            vehplate:vehplate,
            vehcapcity:vehcapcity,
            vehtype:vehtype,
            vehtname:vehtname,
            traplate:traplate,
            driname:driname,
            drilicno:drilicno,
            drilicvalid:drilicvalid,
            driphone:driphone,
            assign:assign_id,
            actfuelempty:actfuelempty,
            actfuelload:actfuelload,
            actperdiumload:actperdiumload,
            actallowanceempty:actallowanceempty,
            acthandlingempty:acthandlingempty,
            acthandlingload:acthandlingload,
            estfuelempty:estfuelempty,
            estfuelload:estfuelload,
            estperdiumload:estperdiumload,
            estallowanceempty:estallowanceempty,
            esthandlingempty:esthandlingempty,
            esthandlingload:esthandlingload,
        })

        temp=this.state.objs.retdrivers.find(o=>o.id==assign_id)
        if(temp!==undefined)
        {
            driname=temp.name
            drilicno=temp.licenceno
            drilicvalid=temp.licencevalidty
            driphone=temp.phoneno
        }
        this.setState({
            [name]: value,
            vehcapcity:vehcapcity,
            vehtype:vehtype,
            vehtname:vehtname,
            traplate:traplate,
            driname:driname,
            drilicno:drilicno,
            drilicvalid:drilicvalid,
            driphone:driphone,
            assignshow: false,
        })
    }*/


    hidecu = () => {
        this.setState({
            cushow: false,
        })
    }
    modalcu = () => {
        return (
            <Modal
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.state.cushow}
                onHide={this.hidecu}>
                <Modal.Header><h4>Order Management</h4></Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="card card-primary">
                                <div className="card-header">
                                    <h3 className="card-title">Get By Date</h3>
                                </div>
                                <form>
                                    <div className="card-body">
                                        <div className="form-group">
                                            <label htmlFor="exampleInputEmail1">Start Date</label>
                                            <input name="st" value={this.state.st} onChange={this.inputmgt}
                                                   type="date" className="form-control"/>
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="exampleInputEmail1">End Date</label>
                                            <input name="ed" value={this.state.ed} onChange={this.inputmgt}
                                                   type="date" className="form-control"/>
                                        </div>
                                    </div>
                                    <div className="card-footer">
                                        <button onClick={this.get_data_by_date} type="submit"
                                                className="btn btn-primary">Get report
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="card card-primary">
                                <div className="card-header">
                                    <h3 className="card-title">Get By Order #</h3>
                                </div>
                                <form>
                                    <div className="card-body">
                                        <div className="form-group">
                                            <label htmlFor="exampleInputEmail1">Order #</label>
                                            <input type="text" name="orderno" value={this.state.orderno}
                                                   onChange={this.inputmgt} className="form-control"/>
                                        </div>
                                    </div>
                                    <div className="card-footer">
                                        <button type="submit" className="btn btn-primary">Get report</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="card-tools">
                                        <div className="input-group input-group-sm" style={{width: '150px'}}>
                                            <input type="text" name="table_search"
                                                   className="form-control float-right" placeholder="Search"/>
                                            <div className="input-group-append">
                                                <button type="submit" className="btn btn-default">
                                                    <i className="fas fa-search"/>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body table-responsive p-0" style={{height: '500px'}}>
                                    <table className="table table-head-fixed text-nowrap">
                                        <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Select</th>
                                            <th>Order Date</th>
                                            <th>Order #</th>
                                            <th>Customer Name</th>
                                            <th>Orgin</th>
                                            <th>Destination</th>
                                            <th>Cargo</th>
                                            <th>Volume</th>
                                            <th>Sale Type</th>
                                            <th>Type</th>
                                            <th>Transport Rate</th>
                                            <th>Cement Rate</th>
                                            <th>Cement Cost</th>
                                            <th>Start Date</th>
                                            <th>Closed Date</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.tabledata()}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
    submitcu = (event, id) => {
        event.preventDefault()
        let baseurl = myconfig.redirecttotruckallocate;
        baseurl = baseurl + "?order_id=" + id
        var win = window.open(baseurl, "_self");
    }

    render() {
        let header = null;
        let edit = null;
        if (this.state.datasl) {
            if (this.state.datas.usermatrix.isadmin || this.state.datas.usermatrix.create) {
                header = <div className="card-header">
                    <div className="card-tools">
                        <div className="input-group input-group-sm" style={{width: '150px'}}>
                            <a href={myconfig.redirecttotruckallocate}
                               className="btn btn-xs btn-outline-primary btn-block">Select Order</a>
                        </div>
                    </div>
                </div>
            }
            if (this.state.datas.usermatrix.isadmin || this.state.datas.usermatrix.create) {
                edit = <th>Edit</th>
            }
        }
        return (
            <>
                <Nav type="allocate_allocate_vehicle"/>
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0">Order Managment</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href={this.state.urlorder}>Order List</a>
                                        </li>
                                        <li className="breadcrumb-item active"></li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="row">
                            {/*<div className="col-md-6">
                                <div className="card card-primary">
                                    <div className="card-header">
                                        <h3 className="card-title">Get By Date</h3>
                                    </div>
                                    <form>
                                        <div className="card-body">
                                            <div className="form-group">
                                                <label htmlFor="exampleInputEmail1">Start Date</label>
                                                <input name="st" value={this.state.st} onChange={this.inputmgt}
                                                       type="date" className="form-control"/>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="exampleInputEmail1">End Date</label>
                                                <input name="ed" value={this.state.ed} onChange={this.inputmgt}
                                                       type="date" className="form-control"/>
                                            </div>
                                        </div>
                                        <div className="card-footer">
                                            <button onClick={this.get_data_by_date} type="submit"
                                                    className="btn btn-primary">Get report
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="card card-primary">
                                    <div className="card-header">
                                        <h3 className="card-title">Get By Order #</h3>
                                    </div>
                                    <form>
                                        <div className="card-body">
                                            <div className="form-group">
                                                <label htmlFor="exampleInputEmail1">Order #</label>
                                                <input type="text" name="orderno" value={this.state.orderno}
                                                       onChange={this.inputmgt} className="form-control"/>
                                            </div>
                                        </div>
                                        <div className="card-footer">
                                            <button type="submit" className="btn btn-primary">Get report</button>
                                        </div>
                                    </form>
                                </div>
                            </div>*/}
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <div className="card-tools">
                                            <div className="input-group input-group-sm" style={{width: '150px'}}>
                                                <input type="text" name="table_search"
                                                       className="form-control float-right" placeholder="Search"/>
                                                <div className="input-group-append">
                                                    <button type="submit" className="btn btn-default">
                                                        <i className="fas fa-search"/>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {header}
                                    <div className="card-body table-responsive p-0" style={{height: '500px'}}>
                                        <table className="table table-head-fixed text-nowrap">
                                            <thead>
                                            <tr>
                                                <th>#</th>
                                                {edit}
                                                <th>Fuel QTY Empty</th>
                                                <th>Per Diem Empty</th>
                                                <th>Handle Fee Empty</th>
                                                <th>Fuel QTY Load</th>
                                                <th>Per Diem Load</th>
                                                <th>Handle Fee Load</th>
                                                <th>Loaded Weight</th>
                                                <th>Unloaded Weight</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {this.tabledata2()}
                                            </tbody>
                                        </table>
                                    </div>
                                    {/* /.card-body */}
                                </div>
                                {/* /.card */}
                            </div>
                        </div>
                    </section>
                </div>

                {this.modalassign()}
                {this.modalcu()}
            </>
        )
    }
}

export default Allocate_allocate_vehicle;
